import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import './CompletedStep';
import Config from '../../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';

const CompletedStep = (props) => {
  const html2canvas = require('html2canvas');
  useEffect(() => {
    gaEvent(
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_DISPLAY.category,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_DISPLAY.eventType,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_DISPLAY.eventParams,
    );
  }, []);

  const screenCapture = () => {
    gaEvent(
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_SCREEN_CAPTURE_BUTTON.category,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_SCREEN_CAPTURE_BUTTON.eventType,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_SCREEN_CAPTURE_BUTTON.eventParams,
    );

    document.getElementById('completed-step-border-corners').style.letterSpacing = '0.1px';
    var printArea = document.querySelector('.completed-step-border-corners');
    html2canvas(printArea).then((canvas) => {
      const downloadLink = document.createElement('a');
      const fileName = 'super-router-connection.png';

      downloadLink.href = canvas.toDataURL();
      downloadLink.download = fileName;
      downloadLink.click();
    });
  };

  const complete = () => {
    gaEvent(
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_FINISH_BUTTON.category,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_FINISH_BUTTON.eventType,
      gaParams.ROUTER_ACTIVATION_WIZARD_COMPLETE_STEP_CLICK_FINISH_BUTTON.eventParams,
    );

    EpiContext.navigateTo(Config.lobbyUrl);
  };

  return (
    <div className='completed-step'>
      <div className='completed-step-title'>גלישה נעימה :)</div>
      <div className='completed-step-text'>התקנתם בהצלחה את הסופר ראוטר</div>
      <div className='completed-step-text'>
        הנה פרטי החיבור שלכם.
        <br />
        כדאי לצלם ולשמור אותם
      </div>
      <BtnWhite text='צילום ושמירת פרטים' onclick={() => screenCapture()} />
      <div id='completed-step-border-corners' className='completed-step-border-corners' style={{textAlign: 'center'}}>
        <div className='completed-step-border-corners-text'>
          <div className='completed-step-cellcom-font'>שם משתמש:{props.UserName}</div>
          <div className='completed-step-cellcom-font'>סיסמא:{props.Password}</div>
          <div className='completed-step-cellcom-font'>שם הרשת האלחוטית:{props.Network}</div>
          <div className='completed-step-cellcom-font'>סיסמת התחברות לרשת אלחוטית:{props.NetPassword}</div>
        </div>
      </div>
      <div className='completed-step-attention-section'>
        <div style={{display: 'flex'}}>
          <Image className='info-icon' src={require('../../images/i-icon/i-icon.svg')} />
          <div className='completed-step-text-small'>
            במידה ושיניתם מהירות גלישה השינוי במהירות
            <br />
            יתבצע תוך כ-24 שעות (בדרך כלל זה קורה לפני)
          </div>
        </div>
        <div className='completed-step-button'>
          <BtnSubmit text='סיום' onclick={() => complete()} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    UserName: state.RouterActivationWizardBlock.form.ispUser,
    Password: state.RouterActivationWizardBlock.form.ispPassword,
    Network: state.RouterActivationWizardBlock.form.network,
    NetPassword: state.RouterActivationWizardBlock.form.netPassword,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CompletedStep);
